import { type TFunction } from 'i18next';

import { SchoolMapper } from '@/shared/category/util/SchoolMapper';
import { isAllGrades } from '@/views/build/util/schoolInfo.util';

/**
 * 자료실 필터(위쪽 필터 막대·모바일 필터 서랍·선택 칩)가 함께 쓰는 학년·학기 이름.
 * 화면마다 따로 만들다 위쪽 필터만 공통 학기를 「9학기」로 보였다.
 */
export const formatGradeLabel = (t: TFunction<['common']>, grade: string) =>
  isAllGrades(grade)
    ? String(t('common:school.info.allGrades'))
    : String(t('common:school.info.nGrade', { n: Number(grade) }));

// 공통 학기는 값이 9 라 'n학기' 문구에 넣지 않는다.
export const formatSemesterLabel = (
  t: TFunction<['common']>,
  semester: string,
) =>
  semester === String(SchoolMapper.COMMON_ID)
    ? String(t('common:school.info.shared'))
    : String(t('common:school.info.nSemester', { n: semester }));
